import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { withLocale } from '../../../../utils/hocs/withLocale';
import { withAuth } from '../../../../utils/hocs/withAuth';
import { AuthLayout } from '../layout';
import { formLabelsState } from '../../../../utils/recoil/formLabels';

export const Login = withAuth(
  withLocale(({ form, help, image, locale, isLoading, onLoginSubmit }) => {
    const [formLabels, setFormlabels] = useRecoilState(formLabelsState);
    const {
      errorLabels,
      successLabels,
      inputs,
      body,
      submitButton,
      secondaryLink,
    } = form;

    const onSubmit = onLoginSubmit;

    useEffect(() => {
      // Set the form labels success & error messages to the ones from the contentful component
      setFormlabels({
        ...formLabels,
        successLabels: successLabels[0].text,
        errorLabels: errorLabels[0].text,
      });
    }, []);

    return (
      <AuthLayout
        image={image}
        locale={locale}
        help={help}
        form={{
          isLoading,
          onSubmit,
          inputs,
          body,
          secondaryLink,
          submitButton: {
            ...submitButton,
            type: 'contained',
            color: { classname: 'primary' },
            size: 'lg',
          },
        }}
      />
    );
  })
);
